export default "__VITE_ASSET__CTy7Jfdj__"